import PropTypes from 'prop-types'
import AdventureReviewRating from './AdventureReviewRating'
import styles from './AdventureSingleReview.module.scss'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

export default function AdventureSingleReview({ review }) {
  const { rating, publishDatetime, text } = review

  return (
    <div className={styles.reviewContainer}>
      <div className={styles.reviewHeader}>
        <AdventureReviewRating
          rating={rating}
          className={styles.smallerStars}
        />
        <span>{dayjs(publishDatetime).fromNow()}</span>
      </div>
      <div className={styles.reviewText}>{text}</div>
    </div>
  )
}

AdventureSingleReview.propTypes = {
  review: PropTypes.object.isRequired,
}
